module.exports = __webpack_public_path__ + "static/media/spinner-gradient.ebaa2678.svg";